import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getDashboardTableData} from "../../redux/Selectors/dashboard.selector";
import {requestDashboardData} from "../../redux/Actions/dashboard.action";

export const useDashboardData = () => {
  const dispatch = useDispatch();
  const dashboardData = useSelector(getDashboardTableData);
  useEffect(() => {
    dispatch(requestDashboardData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {dashboardData};
};
